import { dialNumber } from '$tablet-app/src/app/phone/usePhone';
import React, { FC } from 'react';
import { Text } from '../Text/Text';

interface PhoneNumberProps {
  children: string;
}

const PhoneNumber: FC<PhoneNumberProps> = ({ children }) => {
  const onPress = () => dialNumber(children);
  return (
    <Text preset="phoneNumber" onPress={onPress}>
      {children}
    </Text>
  );
};

export default PhoneNumber;
